import { createContext } from "react";

export const ModalContext = createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
  dismissible: boolean;
}>(null!);
